import { useScreenSize } from '@hooks/useScreenSize/useScreenSize';

export function useMobile() {
  return ['xs'].includes(useScreenSize());
}
